<template>
    <div class="article-home">
        <p>
            Impressive SEO work can make your site more visible, leading to greater visits. However, interesting and
            attractive content is what keeps visitors hooked to your website. Our team of exceptional authors can create
            crisp write-ups that inform readers without being too preachy. Simply creating a website is not enough for a
            business to succeed or captivate customers. You need to infuse regular blogs or articles on the website,
            ensuring a good rank and sustained interest from readers. With great content, your website can improve seo
            and beat the competition.
        </p>
        <p>
            Our team of passionate international writers will handle various niches with personal touch blended with the
            strategic use of keywords. The intent for higher google ranking and keeping the originality and relatability
            factor high are the key result areas. We work towards getting you a wider audience who will find the
            much-needed inspiration to stay on.
        </p>
        <p>
            As an international copy writing agency, the human factor of what we do is paramount - and we apply this
            insight and quality control at scale.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleHome',
};
</script>
